var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlacklistCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "W3A blacklist",
    clipPath: "url(#clip0_25763_99922)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 151",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#E45C51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 8.25L7.99264 4.00736M9.75 6C9.75 8.07107 8.07107 9.75 6 9.75C3.92893 9.75 2.25 8.07107 2.25 6C2.25 3.92893 3.92893 2.25 6 2.25C8.07107 2.25 9.75 3.92893 9.75 6Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25763_99922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklistCircle);
export default __webpack_public_path__ + "static/media/blacklist-circle.d4b9f4f042e4b13fe91bc97c34920182.svg";
export { ForwardRef as ReactComponent };